export default function spaceResponse(response) {
    return response?.data;
}